import { noop } from "nodash"
import { MP4Demuxer } from "../VideoColorFinder/demuxer_mp4"
import { isLocalDevelopmentEnvironment } from "tools/debugging/module"
let i = 0
const isDev = isLocalDevelopmentEnvironment()
function setStatus(type: string, message: string) {
    if (!isDev) return
    if (i % 100 === 0) {
        console.log(type, message)
    }
    i++
}
export const getEmbeddedSrt = async (videoFile: File) => {
    const chunks: string[] = []
    return new Promise<string>((res) => {
        new MP4Demuxer(videoFile, {
            framesInProgress: {},
            onConfig: noop,
            onChunk(chunk: string) {
                chunks.push(chunk)
            },
            setStatus,
            onEnd: () => {
                res(chunks?.join?.(""))
            },
            srt: true,
            setDownloadProgress: () => {},
        })
    })
}
